import { render } from "./SurveyWeb.vue?vue&type=template&id=83fc441a&scoped=true"
import script from "./SurveyWeb.vue?vue&type=script&lang=js"
export * from "./SurveyWeb.vue?vue&type=script&lang=js"

import "./SurveyWeb.vue?vue&type=style&index=0&id=83fc441a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83fc441a"]])

export default __exports__